export default [
  {
    linkTo: "main",
    iconType: "list",
    text: "Lista produktów",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "daily",
    iconType: "date_range",
    text: "Dziennik",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "clientOrders",
    iconType: "speaker_notes",
    text: "Zamówienia klientów",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "reports",
    iconType: "format_list_bulleted",
    text: "Raporty",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "salesPlans",
    iconType: "local_atm",
    text: "Plany sprzedażowe",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "phones",
    iconType: "phone_iphone",
    text: "Telefony na stanie",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "servicesList",
    iconType: "build",
    text: "Serwis telefonów",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "expenses",
    iconType: "monetization_on",
    text: "Wydatki",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "schedule",
    iconType: "schedule",
    text: "Grafik",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "articles",
    iconType: "assignment",
    text: "Baza wiedzy",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "complaints",
    iconType: "low_priority",
    text: "Reklamacje",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "phonesInfo",
    iconType: "attach_money",
    text: "Ceny telefonów",
    show: function(isAdmin) {
      return true
    }
  },
  {
    linkTo: "editProductPrices",
    iconType: "euro_symbol",
    text: "Edycja cen produktów",
    show: function(isAdmin) {
      return isAdmin
    }
  },
  {
    linkTo: "editProductNames",
    iconType: "find_replace",
    text: "Edycja nazw produktów",
    show: function(isAdmin) {
      return isAdmin
    }
  },
  {
    linkTo: "stores",
    iconType: "add_shopping_cart",
    text: "Sklepy",
    show: function(isAdmin) {
      return isAdmin
    }
  },
  {
    linkTo: "colors",
    iconType: "apps",
    text: "Kolory",
    show: function(isAdmin) {
      return isAdmin
    }
  },
  {
    linkTo: "users",
    iconType: "person_add",
    text: "Użytkownicy",
    show: function(isAdmin) {
      return isAdmin
    }
  },
  // {
  //   linkTo: "category",
  //   iconType: "sort",
  //   text: "Kategorie",
  //   show: function(isAdmin) {
  //     return true
  //   }
  // },
 
  // {
  //   linkTo: "wholesales",
  //   iconType: "shopping_cart",
  //   text: "Nasze hurtownie",
  //   show: function(isAdmin) {
  //     return true
  //   }
  // },
  //TODO remove components
  // {
  //   linkTo: "torrework",
  //   iconType: "supervisor_account",
  //   text: "Praca",
  //   show: function(isAdmin) {
  //     return isAdmin
  //   }
  // },
  {
    linkTo: "stats",
    iconType: "pie_chart",
    text: "Statystyki",
    show: function(isAdmin) {
      return isAdmin
    }
  },
  {
    linkTo: "groupProduct",
    iconType: "developer_board",
    text: "Grupowanie Produktów",
    show: function(isAdmin) {
      return isAdmin
    }
  },
  {
    linkTo: "phoneNames",
    iconType: "add_box",
    text: "Nazwy telefonów",
    show: function(isAdmin) {
      return isAdmin
    }
  },
  {
    linkTo: "brands",
    iconType: "stay_current_portrait",
    text: "Modele akcesoriów",
    show: function(isAdmin) {
      return isAdmin
    }
  },
  // TODO
  // clean
  // {
  //   linkTo: "serviceData",
  //   iconType: "description",
  //   text: "Serwis",
  //   show: function(isAdmin) {
  //     return true
  //   }
  // },
  {
    linkTo: "categoryConstraints",
    iconType: "assignment_ind",
    text: "Kategorie produktów",
    show: function(isAdmin) {
      return isAdmin
    }
  }
]



// WEBPACK FOOTER //
// ./src/service/menu.js